import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import axios from '../../../../_services/api/axios';
import withErrorHandler from '../../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../../_store/actions/index';
import Aux from '../../../../_hoc/_Aux';
import { getTranslate } from 'react-localize-redux';
import ReactTooltip from 'react-tooltip'
import * as FormHelpers from '../../../../_helpers/Form.js';

import { Modal, GreyBoxExtra, GreyBoxContent, GreyBox, PageTitle, Form, BoxTitle, InputRow, Input, Text, Button, Select, Toggle, Flex, Spacer } from 'components'


class EditMachineModal extends Component {
	defaultFormState = {
        name : {
            state : false,
            message : false
        },
        multihead : {
            state : false,
            message : false
        },
        heads : {
            state : false,
            message : false
        },
        investment : {
            state : false,
            message : false
        },
        amortization_months : {
            state : false,
            message : false
        },
        speed : {
            state : false,
            message : false
        },
        color_change_time : {
            state : false,
            message : false
        },
        bobbin_stitch_count : {
            state : false,
            message : false
        },
        bobbin_change_time : {
            state : false,
            message : false
        },
        stitches_next_thread_break : {
            state : false,
            message : false
        },
        thread_break_fixing_time : {
            state : false,
            message : false
        },
        hoop_change_time : {
            state : false,
            message : false
        },
        trimming_time : {
            state : false,
            message : false
        },
        cone_change_time : {
            state : false,
            message : false
        },
        maintenance_cost : {
            state : false,
            message : false
        }
    }
    defaultMessageState = {
        show : false,
        message : null
    }
    constructor(props) {
        super(props);
        this.state = {
	        form : {
	            name : this.props.machine.name,
	            multihead : this.props.machine.multihead,
	            heads: this.props.machine.heads,
	            investment: this.props.machine.investment,
	            amortization_months: this.props.machine.amortization_months,
	            speed: this.props.machine.settings.speed,
	            color_change_time: this.props.machine.settings.color_change_time,
	            bobbin_stitch_count: this.props.machine.settings.bobbin_stitch_count,
	            bobbin_change_time: this.props.machine.settings.bobbin_change_time,
	            stitches_next_thread_break: this.props.machine.settings.stitches_next_thread_break,
	            thread_break_fixing_time: this.props.machine.settings.thread_break_fixing_time,
	            hoop_change_time: this.props.machine.settings.hoop_change_time,
	            trimming_time: this.props.machine.settings.trimming_time,
	            cone_change_time: this.props.machine.settings.cone_change_time,
                maintenance_cost: this.props.machine.settings.maintenance_cost,
	            recalculate_all_jobs: false
	        },
	        form_state : this.defaultFormState,
	        message : this.defaultMessageState,
            modalOpen : true,
	        tabs : [{
	    		name : this.props.translate('editmachinemodal.tab_1.name'),
	    		active : true,
	    		batch : false
	    	},{
	    		name : this.props.translate('editmachinemodal.tab_2.name'),
	    		active : false,
	    		batch : this.props.machine.incomplete
	    	}]
		}
	}

    componentDidMount = () => {
        this.incompleteHandler();
    }
    componentWillUnmount = () => {
    	this.props.onCalculatorMachineUpdateReset();
        this.props.onCalculatorMachineDuplicateCheckReset();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if(prevProps.defaults !== this.props.defaults) {
            this.setState(prevState => ({
                ...prevState.tabs,
                tabs : [{
                    name : this.props.translate('editmachinemodal.tab_1.name'),
                    active : true,
                    batch : false
                },{
                    name : this.props.translate('editmachinemodal.tab_2.name'),
                    active : false,
                    batch : this.props.machine.incomplete
                }]
            }))            
        }
        //Duplicate Check
        if(!prevProps.state.name_checked && this.props.state.name_checked) {
            this.setState(prevState => ({
                form_state : {
                    ...prevState.form_state,
                    name : {
                        ...prevState.form_state.name,
                        state : this.props.state.name_available ? 'success' : 'error',
                        message : !this.props.state.name_available ? this.props.translate('editmachinemodal.error.name_exists') : null
                    }
                }
            }));
        }
	    if(this.props.state.updated) {
            this.props.onUpdated();
            this.props.onCalculatorMachineUpdateReset();
            this.props.onHelpersNotificationsMachinesFetch();
            let tabs = [...this.state.tabs];
            tabs[1].batch = this.props.machine.incomplete;
            this.setState(prevState => ({
            	form: {
	                ...prevState.form,
                    recalculate_all_jobs: false
                },
                message: {
                    show: true,
                    message: this.props.translate('editmachinemodal.success.saved'),
                    type: "success"
                },
                tabs: tabs
            }), () => {
                this.props.history.replace("/machines/" + this.props.state.machine.id)
                ReactTooltip.rebuild();
                this.incompleteHandler();
            });
        }
        else if(prevProps.state.error !== this.props.state.error) {
            if(this.props.state.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.error.forEach((error, index) => {
                        if(this.state.form_state[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    [error.source] : {
                                        state : 'error',
                                        message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('editmachinemodal.error.'+this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('editmachinemodal.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('editmachinemodal.error.default'),
                        type: "error"
                    }
                }));
            }
        }
    }

    incompleteHandler = () => {
         if(this.props.machine.incomplete) {
            if(this.props.machine.investment === 0) {
                this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        investment : {
                            ...prevState.form_state.investment,
                            state : 'warning',
                            message : this.props.translate('editmachinemodal.tab_2.error.incomplete')
                        }
                    }
                }));
            }
            if(this.props.machine.amortization_months === 0) {
                this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        amortization_months : {
                            ...prevState.form_state.amortization_months,
                            state : 'warning',
                            message : this.props.translate('editmachinemodal.tab_2.error.incomplete')
                        }
                    }
                }));
            }
        }
    }

    updateHandler = ( event ) => {
        event.preventDefault();
        if(FormHelpers.validateFields.apply(this,[['speed','hoop_change_time','cone_change_time','bobbin_stitch_count','thread_break_fixing_time','color_change_time','trimming_time','bobbin_change_time','stitches_next_thread_break','maintenance_cost','name','investment','amortization_months']])) {
            const formData = {
                name : this.state.form.name,
                heads: this.state.form.heads,
                multihead: this.state.form.multihead,
                investment: this.state.form.investment,
                amortization_months: this.state.form.amortization_months,
                settings: {
                    speed: this.state.form.speed,
                    color_change_time: this.state.form.color_change_time,
                    bobbin_stitch_count: this.state.form.bobbin_stitch_count,
                    bobbin_change_time: this.state.form.bobbin_change_time,
                    stitches_next_thread_break: this.state.form.stitches_next_thread_break,
                    thread_break_fixing_time: this.state.form.thread_break_fixing_time,
                    hoop_change_time: this.state.form.hoop_change_time,
                    trimming_time: this.state.form.trimming_time,
                    cone_change_time: this.state.form.cone_change_time,
                    maintenance_cost: this.state.form.maintenance_cost
                },
                recalculate_all_jobs: true
            };
            this.setState(prevState => ({
                form_state: this.defaultFormState
            }));
            this.props.onCalculatorMachineUpdate(this.props.state.machine.id,formData);
        }
        else {
            this.setState(prevState => ({
                message: {
                    show: true,
                    message: this.props.translate('jobnewpage.error.default'),
                    type: "error"
                }
            }));
        }
    }

    inputChangedToggle = (value, inputIdentifier) => {
    	this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }));
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }));
    }

    onTabClickedHandler = (index) => {
    	let tabs = [...this.state.tabs];

		tabs.map(function(tab, index){
			tab.active = false;
		})
		tabs[index].active = true;
		this.setState(prevState => ({
            tabs: tabs
        }), () => {
            ReactTooltip.rebuild();
        });
    }

    onCloseModal = () => {
        this.setState(prevState => ({
            modalOpen: false
        }))
    }

    inputBlurredHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        if(inputIdentifier === 'name') {
            if(value.length) {
                this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : 'loading'
                        }
                    }
                }));
                this.props.onCalculatorMachineDuplicateCheck({name: value, id: this.props.state.machine.id});
            }
            else {
                this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : false
                        }
                    }
                }));
            }
        }
        FormHelpers.validateFields.apply(this,[[inputIdentifier]]);
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].hideTooltip();
        }
    }
    inputFocusHandler = (event, inputIdentifier) => {
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].showTooltip();
        }
    }

    timesIterator = n => f => {
      let iter = i => {
        if (i === n) return
        f (i)
        iter (i + 1)
      }
      return iter (0)
    }

    render () {
        let headConfig = [];
        this.timesIterator (20) (i => {
            headConfig.push({
                value: i+1,
                name: (i+1) + " " + this.props.translate('global.machine.head.multiple')
            })
        })

        if(!this.state.modalOpen) {
            return (<Redirect to="/machines" />)
        }
        var showMessage;
        if(this.state.message.message) {
            showMessage = this.state.message;
        }
        return (
            <Modal>
                <Form onSubmit={this.updateHandler}>
		      	<GreyBox outerMargin="true" smallMargin="true" tabs={this.state.tabs} closeIcon={this.onCloseModal} onTabClicked={this.onTabClickedHandler} cols="2"  msg_inside={showMessage} title={this.props.machine.name} titleTheme="light">
                    <GreyBoxContent visible={this.state.tabs[0].active}>
    			    	<BoxTitle>{this.props.translate('editmachinemodal.tab_1.box_title')}</BoxTitle>
    			    	<Text>{this.props.translate('editmachinemodal.tab_1.box_text')}</Text>
    			    	<Spacer height="26px" />
    			    	<Flex break="xs">
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.speed')} 
    	                            	unit={this.props.translate('global.units.spm')}
    	                            	cols="2"
                                        ref="speedInputRow"
    	                            	state={this.state.form_state.speed.state ? this.state.form_state.speed.state : null} 
                                        tip={this.state.form_state.speed.message ? this.state.form_state.speed.message : null}
                                        hint={this.props.translate('global.help.machine.speed')}>
    	                        <Input 
    	                            identifier="speed"
                                    ref="speed"
                                    minValue={1}
                                    maxValue={2000}
    	                            type="number"
    	                            value={this.state.form.speed}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.color_change_time')} 
    	                            	unit={this.props.translate('global.units.seconds')}
    	                            	cols="2"
                                        ref="color_change_timeInputRow"
    	                            	state={this.state.form_state.color_change_time.state ? this.state.form_state.color_change_time.state : null} 
                                        tip={this.state.form_state.color_change_time.message ? this.state.form_state.color_change_time.message : null}
                                        hint={this.props.translate('global.help.machine.color_change_time')}>
    	                        <Input 
    	                            identifier="color_change_time"
                                    ref="color_change_time"
                                    minValue={1}
                                    maxValue={1200}
    	                            type="number"
    	                            value={this.state.form.color_change_time}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.hoop_change_time')}  
    	                            	unit={this.props.translate('global.units.seconds')}
    	                            	cols="2"
                                        ref="hoop_change_timeInputRow"
    	                            	state={this.state.form_state.hoop_change_time.state ? this.state.form_state.hoop_change_time.state : null} 
                                        tip={this.state.form_state.hoop_change_time.message ? this.state.form_state.hoop_change_time.message : null}
                                        hint={this.props.translate('global.help.machine.hoop_change_time')}>
    	                        <Input 
    	                            identifier="hoop_change_time"
                                    ref="hoop_change_time"
                                    minValue={1}
                                    maxValue={1200}
    	                            type="number"
    	                            value={this.state.form.hoop_change_time}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.trimming_time')} 
    	                            	unit={this.props.translate('global.units.seconds')}
    	                            	cols="2"
                                        ref="trimming_timeInputRow"
    	                            	state={this.state.form_state.trimming_time.state ? this.state.form_state.trimming_time.state : null} 
                                        tip={this.state.form_state.trimming_time.message ? this.state.form_state.trimming_time.message : null}
                                        hint={this.props.translate('global.help.machine.trimming_time')}>
    	                        <Input 
    	                            identifier="trimming_time"
                                    ref="trimming_time"
                                    minValue={1}
                                    maxValue={1200}
    	                            type="number"
    	                            value={this.state.form.trimming_time}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.cone_change_time')}
    	                            	unit={this.props.translate('global.units.seconds')}
    	                            	cols="2"
                                        ref="cone_change_timeInputRow"
    	                            	state={this.state.form_state.cone_change_time.state ? this.state.form_state.cone_change_time.state : null} 
                                        tip={this.state.form_state.cone_change_time.message ? this.state.form_state.cone_change_time.message : null}
                                        hint={this.props.translate('global.help.machine.cone_change_time')}>
    	                        <Input 
    	                            identifier="cone_change_time"
                                    ref="cone_change_time"
                                    minValue={1}
                                    maxValue={1200}
    	                            type="number"
    	                            value={this.state.form.cone_change_time}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.bobbin_change_time')}
    	                            	unit={this.props.translate('global.units.seconds')}
    	                            	cols="2"
                                        ref="bobbin_change_timeInputRow"
    	                            	state={this.state.form_state.bobbin_change_time.state ? this.state.form_state.bobbin_change_time.state : null} 
                                        tip={this.state.form_state.bobbin_change_time.message ? this.state.form_state.bobbin_change_time.message : null}
                                        hint={this.props.translate('global.help.machine.bobbin_change_time')}>
    	                        <Input 
    	                            identifier="bobbin_change_time"
                                    ref="bobbin_change_time"
                                    minValue={1}
                                    maxValue={1200}
    	                            type="number"
    	                            value={this.state.form.bobbin_change_time}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    				    	<InputRow 	label={this.props.translate('global.form.label.machine.bobbin_stitch_count')}
    	                            	cols="2"
                                        ref="bobbin_stitch_countInputRow"
    	                            	state={this.state.form_state.bobbin_stitch_count.state ? this.state.form_state.bobbin_stitch_count.state : null} 
                                        tip={this.state.form_state.bobbin_stitch_count.message ? this.state.form_state.bobbin_stitch_count.message : null}
                                        hint={this.props.translate('global.help.machine.bobbin_stitch_count')}>
    	                        <Input 
    	                            identifier="bobbin_stitch_count"
                                    ref="bobbin_stitch_count"
                                    minValue={1}
                                    maxValue={100000}
    	                            type="number"
    	                            value={this.state.form.bobbin_stitch_count}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    	                	<InputRow 	label={this.props.translate('global.form.label.machine.stitches_next_thread_break')}
    	                            	cols="2"
                                        ref="stitches_next_thread_breakInputRow"
    	                            	state={this.state.form_state.stitches_next_thread_break.state ? this.state.form_state.stitches_next_thread_break.state : null} 
                                        tip={this.state.form_state.stitches_next_thread_break.message ? this.state.form_state.stitches_next_thread_break.message : null}
                                        hint={this.props.translate('global.help.machine.stitches_next_thread_break')}>
    	                        <Input 
    	                            identifier="stitches_next_thread_break"
                                    ref="stitches_next_thread_break"
                                    minValue={1}
                                    maxValue={999999}
    	                            type="number"
    	                            value={this.state.form.stitches_next_thread_break}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
    	                	<InputRow 	label={this.props.translate('global.form.label.machine.thread_break_fixing_time')} 
    	                				unit={this.props.translate('global.units.seconds')}
    	                            	cols="2"
                                        ref="thread_break_fixing_timeInputRow"
    	                            	state={this.state.form_state.thread_break_fixing_time.state ? this.state.form_state.thread_break_fixing_time.state : null} 
                                        tip={this.state.form_state.thread_break_fixing_time.message ? this.state.form_state.thread_break_fixing_time.message : null}
                                        hint={this.props.translate('global.help.machine.thread_break_fixing_time')}>
    	                        <Input 
    	                            identifier="thread_break_fixing_time"
                                    ref="thread_break_fixing_time"
                                    minValue={1}
                                    maxValue={1200}
    	                            type="number"
    	                            value={this.state.form.thread_break_fixing_time}
    	                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
    	                    </InputRow>
                            <InputRow   label={this.props.translate('global.form.label.machine.maintenance_cost')} 
                                        unit={this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} 
                                        cols="2"
                                        isRight="true"
                                        ref="maintenance_costInputRow"
                                        state={this.state.form_state.maintenance_cost.state ? this.state.form_state.maintenance_cost.state : null} 
                                        tip={this.state.form_state.maintenance_cost.message ? this.state.form_state.maintenance_cost.message : null}
                                        hint={this.props.translate('global.help.machine.maintenance_cost')}>
                                <Input 
                                    identifier="maintenance_cost"
                                    ref="maintenance_cost"
                                    minValue={0}
                                    maxValue={9999999}
                                    type="number"
                                    value={this.state.form.maintenance_cost}
                                    changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
                            </InputRow>
    	                </Flex>
                    </GreyBoxContent>
                    <GreyBoxContent visible={this.state.tabs[1].active}>
				    	<BoxTitle>{this.props.translate('editmachinemodal.tab_2.box_title')}</BoxTitle>
                        <Spacer height="26px" />
				    	<Flex break="xs">
					    	<InputRow 	label={this.props.translate('global.form.label.machine.name')} 
					    	 			cols="2"
                                        ref="nameInputRow"
					    	 			state={this.state.form_state.name.state ? this.state.form_state.name.state : null}
                                        tip={this.state.form_state.name.message ? this.state.form_state.name.message : null}>
		                        <Input 
		                            identifier="name"
                                    ref="name"
		                            type="text"
		                            value={this.state.form.name}
		                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    maxlength={50}
                                    isRequired={true} />
		                    </InputRow>
		                    <InputRow 	label={this.props.translate('global.form.label.machine.heads')} 
					    	 			cols="2"
                                        ref="headsInputRow"
					    	 			state={this.state.form_state.heads.state ? this.state.form_state.heads.state : null}
                                        tip={this.state.form_state.heads.message ? this.state.form_state.heads.message : null}
                                        hint={this.props.translate('global.help.machine.heads')}>
			                    <Select 
			                        identifier="heads"
                                    ref="heads"
			                        options={headConfig}
			                        value={this.state.form.heads}
			                        changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
		                    </InputRow>
		                    <InputRow 	label={this.props.translate('global.form.label.machine.investment')}  
		                            	unit={this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} 
					    	 			cols="2"
                                        ref="investmentInputRow"
					    	 			state={this.state.form_state.investment.state ? this.state.form_state.investment.state : null}
                                        tip={this.state.form_state.investment.message ? this.state.form_state.investment.message : null}
                                        hint={this.props.translate('global.help.machine.investment')}>
		                        <Input 
		                            identifier="investment"
                                    ref="investment"
		                            type="number"
                                    minValue={0}
                                    maxValue={99999999}
		                            value={this.state.form.investment}
		                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
		                    </InputRow>
		                    <InputRow 	label={this.props.translate('global.form.label.machine.amortization_months')} 
		                    			unit={this.props.translate('global.units.months')}
					    	 			cols="2"
                                        ref="amortization_monthsInputRow"
					    	 			state={this.state.form_state.amortization_months.state ? this.state.form_state.amortization_months.state : null}
                                        tip={this.state.form_state.amortization_months.message ? this.state.form_state.amortization_months.message : null}
                                        hint={this.props.translate('global.help.machine.amortization_months')}>
		                        <Input 
		                            identifier="amortization_months"
                                    ref="amortization_months"
                                    minValue={0}
                                    maxValue={240}
		                            type="number"
		                            value={this.state.form.amortization_months}
		                            changed={this.inputChangedHandler}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
		                    </InputRow>
		                    <InputRow label={this.props.translate('global.form.label.machine.multihead')} 
		                    			theme="light"
					    	 			cols="2"
		                            	isRight="true"
		                            	labelStyle="toggleRight"
                                        ref="multiheadInputRow"
		                            	state={this.state.form_state.multihead.state ? this.state.form_state.multihead.state : null}
                                        tip={this.state.form_state.multihead.message ? this.state.form_state.multihead.message : null}>
		                        <Toggle 
		                            identifier="multihead"
                                    ref="multihead"
		                            value={this.state.form.multihead}
		                            changed={this.inputChangedToggle}
                                    blurred={this.inputBlurredHandler}
                                    focused={this.inputFocusHandler}
                                    isRequired={true} />
		                    </InputRow>
		                 </Flex>
                    </GreyBoxContent>
                </GreyBox>
                <GreyBox outerMargin="true" cols="2">
                    <Flex reverse="m">
                        <Button data-cy="cancel-edit-machine-btn" nomargin="true" href="/machines" theme="light" value={this.props.translate('editmachinemodal.secondary.label')} width="320px" />
                        <Button data-cy="save-changes-edit-machine-btn" nomargin="true" value={this.props.translate('editmachinemodal.submit')} type="submit" width="320px" disabled={Object.entries(this.state.form_state).filter(entry => entry[0] !== "amortization_months" && entry[0] !== "investment" && entry[1].state === 'error').length > 0 ? true : false}/>  
                    </Flex>
		      	</GreyBox>
                </Form>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.calculatorMachine,
        translate: getTranslate(state.locale),
        settingsCompany: state.calculatorSettingsCompany
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCalculatorMachineUpdateReset: () => dispatch(actionCreators.calculatorMachineUpdateReset()),
        onCalculatorMachineUpdate: (id, formData) => dispatch(actionCreators.calculatorMachineUpdate(id, formData)),
        onHelpersNotificationsMachinesFetch: () => dispatch(actionCreators.helpersNotificationsMachinesFetch()),
        onFetchMachine: (id) => dispatch(actionCreators.calculatorMachineFetch(id)),
        onCalculatorMachineDuplicateCheck: (formData) => dispatch(actionCreators.calculatorMachineDuplicateCheck(formData)),
        onCalculatorMachineDuplicateCheckReset: () => dispatch(actionCreators.calculatorMachineDuplicateCheckReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withErrorHandler(EditMachineModal, axios)));


// WEBPACK FOOTER //
// ./src/components/pages/MachinesPage/EditMachineModal/index.js